import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.2",
  viewBox: "0 0 32.349 22.541"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M21.671 9.836h0M22.266 21.78a1.44 1.44 0 0 1-1.209.036l-10.03-4.281a1.44 1.44 0 0 1-.875-1.325V6.435a1.44 1.44 0 0 1 .831-1.3l9.4-4.389a1.44 1.44 0 0 1 1.143-.032l9.317 3.723a1.44 1.44 0 0 1 .906 1.336v10.374a1.44 1.44 0 0 1-.8 1.287ZM21.671 9.837l9.808-4.9" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "m10.408 5.614 11.261 4.223v12.09M26.323 7.511 15.691 2.934M.793 12.53l.068.03 5.692 2.629M3.143 8.577l3.41 1.574M4.93 4.362l1.623.749" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }